import { render, staticRenderFns } from "./Adresler.vue?vue&type=template&id=533cdbc5&scoped=true"
import script from "./Adresler.vue?vue&type=script&lang=js"
export * from "./Adresler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533cdbc5",
  null
  
)

export default component.exports